import { Link, Route } from "react-router-dom/cjs/react-router-dom.min";
import AboutMain from "./AboutMain";
import AboutRecord from "./AboutRecord";
import AboutCustomer from "./AboutCustomer";
import AboutMap from "./AboutMap";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function About({ match }) {
  const btnBox = document.getElementsByClassName("basic-item")[0];
  const [box, setBox] = useState(); // eslint-disable-line no-unused-vars
  const [link, setLink] = useState(window.location.href);
  const [name, setName] = useState("");
  const [cont1, setCont1] = useState("");
  const [cont2, setCont2] = useState("");

  const getData = (name, cont1, cont2) => {
    setName(name);
    setCont1(cont1);
    setCont2(cont2);
  };

  const getLink = (lin) => {
    setLink(lin);
  };

  useEffect(() => {
    getLink();
    setBox(btnBox);
  }, [btnBox]);

  //링크에 따른 클래스 부여
  if (link?.includes("overview")) {
    classRemove(btnBox?.children);
    btnBox?.children[0].classList.add("on");
  } else if (link?.includes("record")) {
    classRemove(btnBox?.children);
    btnBox?.children[1].classList.add("on");
  } else if (link?.includes("customer")) {
    classRemove(btnBox?.children);
    btnBox?.children[2]?.classList.add("on");
  } else if (link?.includes("map")) {
    classRemove(btnBox?.children);
    btnBox?.children[3].classList.add("on");
  }

  //버튼 클릭시 이동(임시)
  const onMovePage = (e) => {
    const targetValue = e.target;

    classRemove(btnBox?.children);
    targetValue.parentNode.classList.add("on");
  };

  //on 클래스 삭제
  function classRemove(arr) {
    for (let i = 0; i < arr?.length; i++) {
      arr[i].classList.remove("on");
    }
  }

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      <div className="basic-main">
        <div className="basic-visual about-visual">
          <div className="inner">
            <h2 className="basic-visual-title">{name}</h2>
            <div className="basic-visual-cont">
              {pc ? (
                <>
                  <p>{cont1}</p>
                  <p>{cont2}</p>
                </>
              ) : (
                <>
                  <p>
                    {cont1}
                    {cont2}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="basic-tap">
          <ul className="basic-item" onClick={onMovePage}>
            <li className="basic-list" value={1}>
              <Link to="/about/overview" className="basic-link">
                회사 소개
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list" value={2}>
              <Link to="/about/record" className="basic-link">
                수행 실적
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list" value={3}>
              <Link to="/about/customer" className="basic-link">
                고객사
              </Link>
              <span className="line"></span>
            </li>
            <li className="basic-list" value={4}>
              <Link to="/about/map" className="basic-link">
                오시는 길
              </Link>
              <span className="line"></span>
            </li>
          </ul>
        </div>
      </div>
      <div className="basic-inner">
        <Route
          path={`${match.path}/overview`}
          exact={true}
          render={() => <AboutMain getLink={getLink} getData={getData} />}
        />
        <Route
          path={`${match.path}/record`}
          render={() => <AboutRecord getLink={getLink} getData={getData} />}
        />
        <Route
          path={`${match.path}/customer`}
          render={() => <AboutCustomer getLink={getLink} getData={getData} />}
        />
        <Route
          path={`${match.path}/map`}
          render={() => <AboutMap getLink={getLink} getData={getData} />}
        />
      </div>
    </>
  );
}

export default About;
